import * as React from "react";
import {
  Card,
  Grid,
  Button,
  Backdrop,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import { Barchart } from "./../Charts/BarChart";
import { ResultFiles } from "./../Internalcomponents/ResultFiles";
import { PieChart } from "./../Charts/PieChart";
import { useState } from "react";
import { ApiService } from "../../../utils/ApiService";
import { useEffect, useRef } from "react";
import ShowAlert from "../Internalcomponents/ShowAlert";
import { CustomizedSnackbar } from "../Internalcomponents/CustomizedSnackbar";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import WarningIcon from '@mui/icons-material/Warning';
import Tooltip from '@mui/material/Tooltip';

export const DashboardBarChart = ({ family }) => {
  const barcardstyles = {
    boxShadow: "none",
    borderRadius: "18px",
    width: "52%",
    display: "flex",

    marginTop: "5px",
    marginRight: "18px",
    padding: "1.5rem",
  };

  const resultcardstyles = {
    boxShadow: "none",
    borderRadius: "18px",
    width: "19%",
    display: "flex",
    marginTop: "5px",
    padding: "1rem",
    paddingTop: "0rem",
  };

  const buttonsGrid = {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    margin: "5px",
  };

  const buttonStyles = {
    color: "#353e5a",
    backgroundColor: "#cfdaf4",
    border: "1px solid rgb(244 247 254) ",
    fontFamily: "DM Sans, sans-serif",
  };

  const barChartGrid = {
    width: "70%",
    marginLeft: "auto",
    // marginTop: "auto",
    // marginBottom: "auto"
  };

  const piecardstyles = {
    boxShadow: "none",
    borderRadius: "18px",
    width: "28%",
    display: "flex",
    flexDirection: "column",
    marginTop: "5px",
    marginRight: "18px",
    padding: "1.5rem",
  };

  const pieChartGrid = {
    width: "100%",
    // marginLeft: "3rem",
    marginTop: "auto",
    marginBottom: "auto",
  };

  const failedDataButton = {
    // color: "#f7a00d",
    color: "inherit",
    fontSize: 30,
    "&:hover": {


    }
  }

  const circleBackStyle = {
    "&:hover": {
      backgroundColor: "#e3e1e1",
      color: "#e17727",
      cursor: "pointer",
    },
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    width: 40,
    height: 40,
    borderRadius: "50%",
    backgroundColor: "#f5f5f5",
    color: "#f7a00d",

  };

  const [activeButton, setActiveButton] = useState(0);
  const [family_name, setFamily_name] = useState("");
  const [latest_date, setLatest_date] = useState("");
  const [loadopen, setLoadpen] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorCSV, setErrorCSV] = useState(false);
  const [selectedAlgType, setSelectedAlgType] = useState("");
  const [barchartData, setBarchartData] = useState([]);
  /**
   * Array of button labels for different algorithm types in the dashboard.
   * These labels represent various data analysis and calculation options
   * available for the bar chart visualization.
   */
  const buttonArray = [
    "Raw Data Cleaned",
    "L1 Calculation",
    "Leakage Detection",
    "Cond Fouling",
    "Cond Fouling All Bins",
    "Cond Fouling Trend",
    "Evaporator Fouling",
    "Threshold Analysis",
  ];


  useEffect(() => {
    console.log("call the api for bar chart family : ", family);

    if (family) {
      console.log("family");
      console.log(family);
      featchBarchartData(buttonArray[0], 0);
    }
  }, [family]);

  const featchBarchartData = (algorithmType, index) => {
    setLoadpen(true);
    setActiveButton(index);
    setSelectedAlgType(algorithmType)
    ApiService("get_bar_chart_data", "GET", {
      family_name: family,
      algorithm_type: algorithmType,
    })
      .then((response) => {
        setBarchartData(response.body.data);
        setLatest_date(response.body.data.latestDate);
        setLoadpen(false);
        setErrorAlert(false);
        if (response.body.data.dates <= 0) {
          setErrorAlert(true);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoadpen(false);
        setErrorAlert(true);
      });
  };

  const downloadCSV = (algorithmType) => {
    setLoadpen(true);
    setErrorCSV(false);
    ApiService("get_presigned_url", "GET", {
      family_name: family,
      algorithm_type: algorithmType,
      date: latest_date,
      category: "Result_files"
    })
      .then((response) => {
        console.log(response);
        if (response.body.data) {
          window.location.assign(response.body.data);
        } else {
          setErrorCSV(true);
        }

        setLoadpen(false);
      })
      .catch((error) => {
        console.log(error);
        setLoadpen(false);
        // ShowAlert({severity:"error", message:"Error to be displayed"});
        setErrorCSV(true);
      });
  };

  const downloadUnitStatusData = (url) => {

    setLoadpen(true);
    setErrorCSV(false);

    ApiService(url, "GET", {
      family_name: family,
      algorithm_type: selectedAlgType,
      date: latest_date,
    })
      .then((response) => {
        console.log(response);
        if (response.body.data) {
          window.location.assign(response.body.data);
        } else {
          setErrorCSV(true);
        }

        setLoadpen(false);
      })
      .catch((error) => {
        console.log(error);
        setLoadpen(false);
        setErrorCSV(true);
      });
  }

  return (
    <>
      <Grid
        item
        sx={{
          marginLeft: "2rem",
          marginRight: "3.5rem",
          display: "flex",
          gap: "0.5rem",
        }}
      >
        <Card sx={barcardstyles}>
          <Grid sx={buttonsGrid}>
            {buttonArray.map((buttonText, index) => {
              return (
                <Button
                  key={index}
                  variant="outlined"
                  sx={buttonStyles}
                  style={{
                    backgroundColor:
                      activeButton === index ? "#3f51b5" : "#dfe5f4",
                    color: activeButton === index ? "white" : "#353e5a",
                    fontSize: "13px",
                  }}
                  onClick={() => featchBarchartData(buttonText, index)}
                >
                  {buttonText}
                </Button>
              );
            })}
          </Grid>
          <Grid sx={barChartGrid}>
            <Barchart
              dates={barchartData?.dates}
              values={barchartData?.barValues}
              error={errorAlert}
            />
          </Grid>
        </Card>

        <Card sx={piecardstyles}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: " 0.9375rem",
              fontFamily: "DM Sans, sans-serif",
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <span>Units status</span>
            <Tooltip title="Error log" placement="left-start">
              <Box sx={circleBackStyle} onClick={() => {downloadUnitStatusData("get_failed_data_url")}}>
                <DownloadForOfflineIcon sx={failedDataButton} />
              </Box>
            </Tooltip>

            {/* <Button variant="outlined" onClick={downloadFailedData} sx={failedDataButton}> Failed Data <DownloadForOfflineIcon sx={{ marginLeft: '5px' }} /></Button> */}
          </div>

          <Grid sx={pieChartGrid}>
            <PieChart pieData={barchartData?.pieData} error={errorAlert} downloadUnitStatusData={downloadUnitStatusData} />
          </Grid>
        </Card>

        <Card sx={resultcardstyles}>
          <ResultFiles
            downloadCSVFile={downloadCSV}
            error={errorCSV}
          ></ResultFiles>
        </Card>



        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadopen}
        >
          <CircularProgress size="4rem" />
        </Backdrop>

        <CustomizedSnackbar
          action={errorCSV}
          message="Unable to find file in s3"
        />
      </Grid>
    </>
  );
};
